export default __webpack_public_path__ + "static/media/geology-venus.484f9dac.png";